// utils/validateForm.js

const formatFieldName = (str) =>
  str
    .replace(/([A-Z])/g, ' $1') // insert space before capital letters
    .replace(/^./, (c) => c.toUpperCase()); // capitalize first letter

const validateForm = (formData, config = {}) => {
    const {
      requiredFields = [],
      requiredArrayFields = [],
      patternRules = {},
    } = config;
  
    const errors = {};
  
    // Validate required fields (strings/numbers)
    requiredFields.forEach((field) => {
      const value = formData[field];
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "") ||
        (typeof value === "number" && isNaN(value))
      ) {
        errors[field] = `${formatFieldName(field)} is required`;
      }
    });
  
    // Validate required array fields
    requiredArrayFields.forEach((field) => {
      const value = formData[field];
      if (!Array.isArray(value) || value.length === 0) {
        errors[field] = `${formatFieldName(field)} must not be empty`;
      }
    });
  
    // Validate pattern rules
    Object.entries(patternRules).forEach(([field, { pattern, message }]) => {
      const value = formData[field];
      if (value && !pattern.test(value)) {
        errors[field] = message || `${formatFieldName(field)} is invalid`;
      }
    });
  
    return errors;
  };
  
  export default validateForm;